import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { Loading } from '@/components/feedback/Loading'
import { useAuth } from '@/hooks/use-auth'

const CHANGE_PASSWORD_PATH = '/hesap/parola'

/**
 * Oturum kapısı: bootstrap tamamlanana kadar bekler, oturum yoksa girişe yönlendirir.
 * `must_change_password` açıkken parola değiştirme dışındaki tüm rotalar oraya
 * yönlendirilir (görev dosyası) — karar backend'den gelen bayrağa dayanır, burada
 * yalnızca yönlendirme yapılır.
 */
export function RequireAuth() {
  const { isBootstrapping, isAuthenticated, mustChangePassword } = useAuth()
  const location = useLocation()

  if (isBootstrapping) {
    return (
      <div className="flex h-dvh items-center justify-center">
        <Loading rows={3} />
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/giris" replace state={{ from: location }} />
  }

  if (mustChangePassword && location.pathname !== CHANGE_PASSWORD_PATH) {
    return <Navigate to={CHANGE_PASSWORD_PATH} replace />
  }

  return <Outlet />
}
